var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/lodash/_nativeCreate.js
// module id = SiCv
// module chunks = 1